import { ChartInteractiveSort, DescriptorColumn, LegendColumn, ValueColumn } from '../../../dashboard/models/chart';
import { DashboardColumn } from '../../../dashboard/models/dashboard-column';
import { Filter } from '../../../dashboard/models/filter';
import { Column } from '../../models/column.model';

export interface IDataModuleColumn {
  getDataColumnIcon(): string;
}


export function getIconBaseOnColumnType(columnType: string | undefined): string | undefined {
  switch (columnType) {
    case 'CalculateColumn':
      return 'customColumn';
    case 'Measure':
      return 'measure';
    case 'ConditionalColumn':
      return 'customColumn';
    default:
      return undefined;
  }
}

export function getIconParameterOnColumnType(columnType: string | undefined): string | undefined {
  switch (columnType) {
    case 'OriginalColumn':
      return 'parameterColumn';
    case 'Measure':
      return 'parameterMeasure';
    default:
      return undefined;
  }
}

export function getColumnMissedIcon(data: any): string | undefined {
  if (data?.columnIsMissed) {
    return 'warning';
  } else {
    return undefined;
  }
}

export function getIconBaseOnColumnDataType(dataType: string | undefined): string | undefined {
  switch (dataType) {
    case 'Binary':
      return 'quality';
    case 'Boolean':
      return 'quality';
    case 'Currency':
      return 'quantity';
    case 'Date':
      return 'calendar';
    case 'DecimalNumber':
      return 'quantity';
    case 'Text':
      return 'quality';
    case 'WholeNumber':
      return 'quantity';
  }
}
